import { parseMessage } from '@/components/chat/parseMessage';
import type { InquiryParticipant } from '@/hooks/useChat';
import type { ChatConversation } from '@/services/chat/chatTransport';

/**
 * Fetches one page of messages from a conversation and maps them onto the app's
 * chat message model, newest-first to match the inverted message list.
 *
 * Extracted from ChatContent so the message-fetch path is importable on its own
 * — a test can exercise it (and the transport seam behind it) without pulling
 * in the full ChatContent render tree and its GiftedChat dependency.
 */
export const fetchConversationMessages = async (
  conversation: ChatConversation,
  recipient: InquiryParticipant,
  prevMessageId?: number
) => {
  const { hasPrevPage, items } = await conversation.getMessages(10, prevMessageId);

  const parsedMessages = items.map((message) => parseMessage(message, recipient));

  return {
    hasPreviousPage: hasPrevPage,
    messages: parsedMessages.reverse(),
  };
};
